<div fxLayout="column">
  <h2>{{ title }}</h2>
  <ng-container *ngIf="canEditForm$ | async">
    <fieldset>
      <legend>
        <p>
          Your choice will apply to all the accounts you open during this
          session.
        </p>
      </legend>
      <form [formGroup]="accountOwnershipForm" *ngIf="canEditForm$ | async">
        <mat-radio-group formControlName="isIndividual">
          <mat-radio-button [value]="true">Individual</mat-radio-button>
          <mat-radio-button
            aria-describedby="joint-info"
            [value]="false"
            *ngIf="canHaveJointAccount$ | async"
            >Joint</mat-radio-button
          >
        </mat-radio-group>
      </form>
      <br />
      <p id="joint-info" class="attention">
        For joint ownership, applicants must be physically present and submit
        required documents at the same time.
      </p>
    </fieldset>
  </ng-container>
  <ng-container *ngIf="!(canEditForm$ | async)">
    <span class="bold">{{ ownership$ | async }}</span>
  </ng-container>
</div>
